import {
  GET_POSTS,
  GET_INFINITE_SCROLL_POSTS,
  GET_POSTS_BY_REACTION,
  POST_ERROR,
  UPDATE_REACTION,
  DELETE_POST,
  ADD_POST,
  PIN_POST,
  UNPIN_POST,
  ADD_COMMENT,
  REMOVE_COMMENT,
  REMOVE_REPLY,
  ADD_POST_REPLY,
  CLEAR_POSTS,
  CLEAR_MSG,
} from "../actions/types";

const initialState = {
  posts: [],
  comments: [],
  replies: [],
  reactions: [],
  errorMessage: "",
  post: null,
  posts_loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_POSTS:
      return {
        ...state,
        posts: [...state.posts, payload.posts].flat(),
        comments: [...state.comments, payload.comments].flat(),
        replies: [...state.replies, payload.replies].flat(),
        reactions: payload.reactions,
        posts_loading: false,
      };
    case GET_INFINITE_SCROLL_POSTS:
      return {
        ...state,
        posts: [...state.posts, payload.posts].flat(),
        comments: [...state.comments, payload.comments].flat(),
        replies: [...state.replies, payload.replies].flat(),
        reactions:
          state.reactions.length > 0
            ? [...state.reactions, payload.reactions]
            : payload.reactions,
        posts_loading: false,
      };
    case GET_POSTS_BY_REACTION:
      return {
        ...state,
        posts: [...payload.posts].flat(),
        comments: [...payload.comments].flat(),
        replies: [...payload.replies].flat(),
        reactions: payload.reactions,
        posts_loading: false,
      };
    case ADD_POST:
      return {
        ...state,
        errorMessage: payload.msg ? payload.msg : "",
        posts: payload.msg
          ? [...state.posts]
          : [
              payload,
              ...state.posts.sort((a) => {
                const pinned = a.pinned;

                if (pinned) {
                  return -1;
                } else {
                  return 1;
                }
              }),
            ],
        posts_loading: false,
      };
    case DELETE_POST:
      return {
        ...state,
        posts: [
          ...state.posts.filter((post) => post._id.toString() !== payload),
        ],
        posts_loading: false,
      };
    case PIN_POST:
      return {
        ...state,
        posts: payload,
        posts_loading: false,
      };
    case UNPIN_POST:
      return {
        ...state,
        posts: payload,
        posts_loading: false,
      };
    case POST_ERROR:
      return {
        ...state,
        error: payload,
        posts_loading: false,
      };
    case UPDATE_REACTION:
      return {
        ...state,
        reactions: payload.exact
          ? state.reactions.filter((reaction) => reaction._id !== payload.id)
          : payload.found
          ? [
              payload.userObject,
              ...state.reactions.filter(
                (reaction) => reaction._id !== payload.id
              ),
            ]
          : payload.none
          ? [payload.userObject, ...state.reactions]
          : [],
        posts_loading: false,
      };
    case ADD_COMMENT:
      return {
        ...state,
        comments: [payload, ...state.comments],
        posts_loading: false,
      };
    case REMOVE_COMMENT:
      return {
        ...state,
        comments: state.comments.filter((comment) => comment._id !== payload),
        posts_loading: false,
      };
    case ADD_POST_REPLY:
      return {
        ...state,
        replies: [payload, ...state.replies],
        posts_loading: false,
      };
    case REMOVE_REPLY:
      return {
        ...state,
        replies: state.replies.filter((reply) => reply._id !== payload),
        posts_loading: false,
      };
    case CLEAR_MSG:
      return {
        ...state,
        errorMessage: "",
      };
    case CLEAR_POSTS:
      return {
        ...state,
        posts: [],
        comments: [],
        replies: [],
        reactions: [],
        post: null,
        posts_loading: true,
        error: {},
      };
    default:
      return state;
  }
}
